import React from 'react';

/*
 * Icons for the detail-page status chips (src/common/DetailStatusChip.jsx → DETAIL_STATUS).
 * Artwork from the design; stroke / fill colours as supplied.
 */

export const OpenStatusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M18.25 8.33366C17.4778 4.52993 14.1149 1.66699 10.0833 1.66699C5.48096 1.66699 1.75 5.39795 1.75 10.0003C1.75 14.6027 5.48096 18.3337 10.0833 18.3337C10.9543 18.3337 11.7942 18.2 12.5833 17.9522"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="square"
        />
        <path d="M10.082 6.66699V10.0003L11.7487 11.667" stroke="black" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M16.75 15.0003V11.667" stroke="black" strokeWidth="1.5" strokeLinecap="square" />
        <path
            d="M16.8555 18.1253H16.7513M16.9596 18.1253C16.9596 18.2404 16.8664 18.3337 16.7513 18.3337C16.6362 18.3337 16.543 18.2404 16.543 18.1253C16.543 18.0102 16.6362 17.917 16.7513 17.917C16.8664 17.917 16.9596 18.0102 16.9596 18.1253Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

/** Clipboard with a tick — used for both the Authorized and the Work Order chip. */
const ClipboardCheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.16667 18.3321H2.50003L2.5 2.91699H5.83337M12.5 2.91699H15.8333V11.667" stroke="black" strokeWidth="1.5" strokeLinecap="square" />
        <path
            d="M11.2487 1.66699H7.08203C6.39167 1.66699 5.83203 2.22663 5.83203 2.91699C5.83203 3.60735 6.39167 4.16699 7.08203 4.16699H11.2487C11.939 4.16699 12.4987 3.60735 12.4987 2.91699C12.4987 2.22663 11.939 1.66699 11.2487 1.66699Z"
            fill="black"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="square"
        />
        <path d="M5.83203 12.5003H8.6892M5.83203 9.16699H12.4987" stroke="black" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M17.5013 14.167L13.3346 18.3337L11.668 16.667" stroke="black" strokeWidth="1.5" strokeLinecap="square" />
    </svg>
);

export const AuthorizedStatusIcon = ClipboardCheckIcon;
export const WorkOrderStatusIcon = ClipboardCheckIcon;

export const InvoicedStatusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M15 14.167H5V12.5003H15V14.167ZM15 10.8337H5V9.16699H15V10.8337ZM15 7.50033H5V5.83366H15V7.50033ZM2.5 18.3337L3.75 17.0837L5 18.3337L6.25 17.0837L7.5 18.3337L8.75 17.0837L10 18.3337L11.25 17.0837L12.5 18.3337L13.75 17.0837L15 18.3337L16.25 17.0837L17.5 18.3337V1.66699L16.25 2.91699L15 1.66699L13.75 2.91699L12.5 1.66699L11.25 2.91699L10 1.66699L8.75 2.91699L7.5 1.66699L6.25 2.91699L5 1.66699L3.75 2.91699L2.5 1.66699V18.3337Z"
            fill="white"
        />
    </svg>
);

export const SentStatusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15" fill="none">
        <path
            d="M18.3333 9.19123e-08C18.7959 -0.000146281 19.2414 0.174539 19.5805 0.489039C19.9197 0.803538 20.1274 1.23461 20.1621 1.69583L20.1667 1.83333V12.8333C20.1668 13.2959 19.9921 13.7414 19.6776 14.0805C19.3631 14.4197 18.9321 14.6274 18.4708 14.6621L18.3333 14.6667H3.66667C3.20414 14.6668 2.75865 14.4921 2.4195 14.1776C2.08035 13.8631 1.87261 13.4321 1.83792 12.9708L1.83333 12.8333V11.9167H3.66667V12.8333H18.3333V3.1295L11.9717 9.49117C11.731 9.73175 11.4098 9.87457 11.0699 9.89201C10.7301 9.90945 10.3959 9.80027 10.1319 9.58558L10.0274 9.49117L3.66667 3.1295V3.66667H1.83333V1.83333C1.83319 1.3708 2.00787 0.925314 2.32237 0.586164C2.63687 0.247015 3.06794 0.0392731 3.52917 0.00458353L3.66667 9.19123e-08H18.3333ZM5.5 8.25C5.74312 8.25 5.97627 8.34658 6.14818 8.51849C6.32009 8.69039 6.41667 8.92355 6.41667 9.16667C6.41667 9.40978 6.32009 9.64294 6.14818 9.81485C5.97627 9.98676 5.74312 10.0833 5.5 10.0833H0.916667C0.673552 10.0833 0.440394 9.98676 0.268485 9.81485C0.0965771 9.64294 0 9.40978 0 9.16667C0 8.92355 0.0965771 8.69039 0.268485 8.51849C0.440394 8.34658 0.673552 8.25 0.916667 8.25H5.5ZM17.0372 1.83333H4.96283L11 7.8705L17.0372 1.83333ZM4.58333 5.5C4.81697 5.50026 5.0417 5.58972 5.21159 5.75011C5.38148 5.9105 5.48372 6.12971 5.49741 6.36294C5.5111 6.59618 5.43522 6.82585 5.28526 7.00501C5.1353 7.18418 4.92259 7.29932 4.69058 7.32692L4.58333 7.33333H1.83333C1.59969 7.33307 1.37497 7.24361 1.20508 7.08322C1.03519 6.92283 0.932951 6.70363 0.919259 6.47039C0.905567 6.23715 0.981452 6.00748 1.13141 5.82832C1.28137 5.64915 1.49408 5.53401 1.72608 5.50642L1.83333 5.5H4.58333Z"
            fill="black"
        />
    </svg>
);

export const ReapproveStatusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M2.54577 10.8333C2.51552 10.5597 2.5 10.2817 2.5 10C2.5 5.85787 5.85787 2.5 10 2.5C12.4161 2.5 14.5653 3.64247 15.9371 5.41667M17.4543 9.16667C17.4845 9.44025 17.5 9.71833 17.5 10C17.5 14.1422 14.1422 17.5 10 17.5C7.58389 17.5 5.43462 16.3575 4.06296 14.5833"
            stroke="#141B34"
            strokeWidth="1.5"
            strokeLinecap="square"
        />
        <path d="M13.334 5.83333H16.6673V2.5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M6.66732 14.167H3.33398V17.5003" stroke="#141B34" strokeWidth="1.5" strokeLinecap="square" />
    </svg>
);
